import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getRefundReleaseAgentInput,
  getRefundReleaseAgentsInput,
  RefundReleaseAgentLiteModel,
  RefundReleaseAgentModel,
} from './model';

export function useGetRefundReleaseAgents(
  input?: getRefundReleaseAgentsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<RefundReleaseAgentLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<RefundReleaseAgentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['release-purchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'release-purchases',
          params: input?.params,
        }),
      options,
    ),
    RefundReleaseAgentLiteModel,
  );
}

export function useGetRefundReleaseAgent(
  input?: getRefundReleaseAgentInput,
  options?: UseQueryOptions<ApiResult<RefundReleaseAgentModel>, ApiError>,
): UseQueryResult<ApiResult<RefundReleaseAgentModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['release-purchase', input?.id],
      () =>
        QueryFetchFunction({
          url: `release-purchases/${input?.id}`,
        }),
      options,
    ),
    RefundReleaseAgentModel,
  );
}

export function getRefundReleaseAgentsKey(input?: getRefundReleaseAgentsInput) {
  return ['release-purchases', input?.params];
}

export function getRefundReleaseAgentKey(input?: getRefundReleaseAgentInput) {
  return ['release-purchase', input?.id];
}
